import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=a338023e&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a338023e')) {
      api.createRecord('a338023e', component.options)
    } else {
      api.reload('a338023e', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=a338023e&", function () {
      api.rerender('a338023e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28e3WUjVL6GD6/JS/comp/ImgFallback2.vue"
export default component.exports